<template>
  <div>
    <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header p-2">
            <h6 class="modal-title">{{$t('Manage')}} {{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}}</h6>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
              <span aria-hidden="true">
                <cancel-icon class="close-icon" style="height: 30px !important;
                  width: 30px !important;
                  color: #fff;">
                </cancel-icon>
              </span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="primary-btn-style" style="display: flex;height:50px;align-items: center;">
              <button class="btn btn-outline-secondary mr-2" @click.prevent="deleteDepartmentButtonClick()" data-dismiss="modal">{{$t('Delete')}}</button>
              <button class="btn btn-outline-secondary mr-2" data-dismiss="modal" @click.prevent="allowToOpenDepartmentEditDialog">{{$t('Edit')}}</button>
              <button class="btn btn-outline-primary mr-3" @click.prevent="showAddOrEditSource = 'add'">{{$t('Add')}}</button>
            </div>
            <div class="deparments-list-wrapper h-100" style="overflow:auto;display:inline-block">
              <ul v-if="sourceList.length !=0" class="tags-display-ul p-0 active-tag" style="padding:10px !important;display: flex;flex-wrap: wrap;">
                  <li v-for="source in sourceList" :key="source._id" tabindex="0" :class="{activeSource: selectedSource && selectedSource._id == source._id && selectedSource.name != 'All'}" class="view-tags" v-on:click="selectsources(source)">
                      <span v-if="'logo' in source && source.logo" class="img-span"><img :src="getProxyConvertedURL(source.logo)" /></span>
                      <!-- <span v-else>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16" style="color: #4e4e4e;margin-inline-start:4px">
                          <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
                          <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z"/>
                        </svg>
                      </span>   -->

                    <span class="name-span">{{source.name}}</span>
                  </li>
              </ul>
              <ul v-else style="color:#7a7a7a;display: flex;
              justify-content: center;
              margin-top: 27px;">No {{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}} created</ul>
            </div>
          </div>
          <!-- <div class="modal-footer primary-btn-style">
            <button class="btn btn-outline-secondary mr-2" data-dismiss="modal" @click="close">Cancel</button>
            <button class="btn btn-outline-primary mr-3" @click.prevent="updateCatalogPermission()">Update</button>
          </div> -->
        </div>
      </div>
    </div>
    <AddOrEditSource v-if="showAddOrEditSource" :dialogType="showAddOrEditSource" :selectedSource="selectedSource" @close="showAddOrEditSource = null;selectedSource = null"></AddOrEditSource>
  </div>
</template>
  
  <script>
  import cancelIcon from "../core/InlineCancelField.vue";
  import {mapActions,mapGetters, mapMutations} from 'vuex';
  import AddOrEditSource from "./AddOrEditSource.vue";
  import {NotifierConstants} from "../../components.constants.js";

  export default {
    props:["selectedCategory"],
    data(){
      return{
        sourceList: [],
        selectedSource:null,
        showAddOrEditSource:null
      }
    },
    computed:{
        globalSettingsFromStartup:{
          get(){
            return this.$store.state.startUpData.startUpDataDetails;
          }
        },
        ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserPrivilege"]),
    },
    components:{
      'cancel-icon':cancelIcon,
      AddOrEditSource
    },
    methods:{
      close(){
        this.$emit("close");
      },
      selectsources(source){
        if(source.name == 'All'){
          return;
        }
          if(!this.selectedSource || this.selectedSource._id != source._id){
            this.selectedSource = source;
          }else{
            this.selectedSource = null
          }
      },

      allowToOpenDepartmentEditDialog(){
        if(this.selectedSource == null){
          alert(`Select the ${this.globalSettingsFromStartup.department_alias &&  this.globalSettingsFromStartup.department_alias.alias_name?this.globalSettingsFromStartup.department_alias.alias_name:"Department"}`);
          return false;
        }  

        this.showAddOrEditSource = 'edit'
      },

      deleteDepartmentButtonClick(){
        if(!this.selectedSource){
          alert(`No ${this.globalSettingsFromStartup.department_alias &&  this.globalSettingsFromStartup.department_alias.alias_name?this.globalSettingsFromStartup.department_alias.alias_name:"Department"} is selected`);
          return;
        }
        if (confirm(`Are You sure you want to delete the selected ${this.globalSettingsFromStartup.department_alias &&  this.globalSettingsFromStartup.department_alias.alias_name?this.globalSettingsFromStartup.department_alias.alias_name:"Department"} : "${this.selectedSource.name}" ?`)) {
          let payload = {'params':{'_id':this.selectedSource._id}};
          this.deleteDepartment(payload).then((data) => {
            if (data.statusCode==200){
              this.$toast.success(data.message);
              this.getAllDepartments();
            }else{
              this.$toast.error(data.message);
            }
          })
        }
      },
      getAllDepartments(){
        this.getDepartments().then((data) => {
          this.sourceList = data.department;
        })
      },

      handleDepartmentNotifications(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          let departmentInfo = notification.message
          if(departmentInfo){
              if(notification.message_type == NotifierConstants.departmentCreated){
                this.sourceList.push(departmentInfo);
              }
              if(notification.message_type == NotifierConstants.departmentUpdated){
                let indx = this.sourceList.findIndex(op=>op._id == departmentInfo._id);
                if(indx >= 0){
                    this.sourceList[indx] = departmentInfo;
                }
              }
              if(notification.message_type == NotifierConstants.departmentDeleted){
                  this.sourceList = this.sourceList.filter(op=>op._id != departmentInfo._id);
              }
          }  
      },
      registerforWebsocketNotifications(){
          this.addWSEventListener({eventname:[NotifierConstants.departmentCreated, NotifierConstants.departmentUpdated, NotifierConstants.departmentDeleted], callback:this.handleDepartmentNotifications,parent:"TagMetadata"})
      },
      unRegisterforWebsocketNotifications(){
          this.removeWSEventListener({eventname:[NotifierConstants.departmentCreated, NotifierConstants.departmentUpdated, NotifierConstants.departmentDeleted], callback:this.handleDepartmentNotifications,parent:"TagMetadata"})
      },

      ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
      ...mapActions("miscellaneous", ["getDepartments","createDepartment","updateDepartmentInfo","deleteDepartment"]),
    },
    created(){
      this.getAllDepartments();
      this.registerforWebsocketNotifications();
    },
    beforeDestroy(){
        this.unRegisterforWebsocketNotifications();
    }
  }
</script>
  
  <style scoped lang="scss">
  $table-row-border: none;
  $active-blue: #007bff;
  $danger-color: #dc3545;
  $none-text-color:#4f4f4f;
  $add-button-text-color:#0b7099;
  $add-button-text-color-hover:#0193cc;
  $add-button-border-color:#b7b228;
  $add-button-border-on-hover:#dcd426;
  $add-button-backgroud:#1e1e1e;
  $active-green-color:#28a745;
  $primary-background: #1a1e21;
  $border-color: 1px solid #4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555; 
  $input-field-padding:.375rem 10px;
  $filter-border-color: #5a5a5a;
  $filter-bg-color: #2a2a2a;
  $learn-about-text-color-hover:#b7b327;
  $learn-about-text-color:#9a9620;
  $tags-background-color:#282d31;
  $svg-color:#666;
  $tags-border-color:#363636;
  $secondary-border-color: 1px solid #2b2b2b;
  $icon-hover:#2c3339;
  
  .modal-dialog {
      max-width: 470px;
      width: 470px;
      // height: 200px;
      margin: 0;
      padding: 0;
    }
    
    .modal-content {
      height: auto;
      min-height: 100%;
      border: 0 none;
      border-radius: 0;
      box-shadow: none;
       background: $primary-background !important;
      border: $secondary-border-color;
      .modal-body{
        background: $primary-background;
        height: 300px;
        user-select: text !important; 
        cursor:text;
      }
    }
  
  .modal {
      text-align: center;
      padding: 0 !important;
      display: inline-flex;
      position: fixed;
      inset-inline-start: 0px;
      align-items: center;
      justify-content: center;
  }
  .modal:before {
      content: "";
      display: inline-block;
      height: 100vh;
      vertical-align: middle;
      margin-inline-end: -4px;
      position: fixed;
      width: 100vw;
      inset-inline-start: 0;
      top: 0;
      background: #00000094;
  }
  .modal:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    margin-inline-end: -4px;
  }
  .modal-dialog {
    display: inline-block;
    text-align: start;
    vertical-align: middle;
  }
  
  .btn{
      font-size:14px !important;
      height:100%;
  }
  
  
  .border{
      border: $border-color !important;
  }
  
  .activeclass{
      color: $active-blue;
  }
  
  .modal-header,.modal-footer{
      border-top: $secondary-border-color !important;
      border-bottom: $secondary-border-color !important;
      background: $secondary-background-color;
      .modal-title{
        color:$text-color;
      }
  }
  .modal-footer{
    padding: 5px 0px;
  }
  
  .modal-header .close {
      // margin: -1rem -13px -1rem auto !important;
       margin:0px !important;
    padding: 0px !important;
  }
  
  ul{
      list-style-type: none;
  }
  
  .primary-btn-style{
      // margin-top:2%;
      justify-content: flex-end;
      button{
        height: 35px;
        width: 70px;
        font-size:14px;
      }
  }
  
  .secondary-btn-style{
    color:$text-color;
  }
  .close-icon:hover{
    background: $icon-hover;
    border-radius: 20px;
  }
  .nav-item{
      color: $dull-text-color !important;
  }
  .inactive:hover{
    color:$text-color !important;
  }
  .active{
      background: $primary-background !important;
      color:$active-blue  !important;
      border-bottom: 2px solid $active-blue ;
  }
  .top-nav-bar{
      text-align: center;
      background: $primary-background;
  }
  
  /* width */
    ::-webkit-scrollbar {
      width: 8px;
      height:8px;
    }
  
    /* Track */
    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background !important;
    }
  
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background !important;
    }
  
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: $bg-color-on-hover !important;
    }
  
  .common-input-field{
      margin-inline-start: 3%;
      display: inline-block;
      width: 96%;
      justify-content: space-between;
      display: inline-block;
      padding: 9px;
      border-radius: 4px;
      background: $primary-background;
      border: $secondary-border-color !important;
      label{
          width: 30%;
          color: $secondary-text-color;
          word-break: break-word;
      }
      input{
          flex:1;
      }
  }
  .input-text-field{
      height: 44px;
      width: 100% !important;
      padding-inline-start: 2%;
      padding-inline-end:2%;
      overflow: hidden;
  }
  
    .add-border{
      border: $border-color;
    }
  
    .minMaxTextarea{
      min-height: 38px;
    }
  
    textarea:focus{
      outline: none;
      bottom: 0px;
      inset-inline-start: 0px;
      --saf-0: rgba(var(--sk_highlight,18,100,163),1);
      box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
      border-radius: 4px;
      border-color: transparent;
      -webkit-appearance: none;
    }
  
    .view-tags{
      font-size: 12px;
      height: 36px;
      display: inline-flex;
      margin:2px !important;
      border: 1px solid $tags-border-color !important;
      border-radius: 15px !important;
      min-width: 50px;
      padding: 4px !important;
      text-align: center;
      width:auto !important;
      background: $tags-background-color;
      color: $text-color;
      justify-content: center;
      span.name-span{
              padding: 0px 6px;
              margin-inline-start: 0px;
              font-size: 12px;
              border-radius: 15px !important;
              position: relative;
              display: inline-flex;
              align-items: center;
              word-break: break-all;
              // top: 2px;
      }
      span.img-span{
        width: 30px;
        height: 25px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        padding: 0px;
        margin-inline-start: 4px;
        img{
          max-width: 100%;
          max-height: 100%;
          border-radius: 4px;
          object-fit: contain;
          display: inline-block;
        }
      }  
  }
  
  .view-tags:hover{
      border: 1px solid #3a3a3a !important;
  }
  
  
    .dull-the-text{
      color: $dull-text-color;
    }
  
    ::placeholder {
      color: $dull-text-color !important;
    }

    .config-desc{
        color: $dull-text-color;
        font-size: 15px;
        margin-top: 1px;
    }

    .custom-control-label{
        line-height:25px;
    }

    .config-desc,.custom-control{
        text-align: initial;
    }

    .custom-switch .custom-control-label::before{
        background: transparent;
    }
    .custom-control-input:checked~.custom-control-label:before {
        color: #fff;
        border-color: #007bff;
        background-color: #007bff !important;
    }

    .users-basic-info-table {
        tbody {
          margin: 10px;
          .key-div {
            text-align: start;
            padding-inline-start: 3% !important;
            display: flex;
            align-items: center;
            svg{
                margin-inline-end:5px;
            }
          }
          .value-div {
            text-align: start;
            margin-inline-start: 10px;
            width: 30%;
            font-weight: 500;
            vertical-align: middle;
            input,select{
              padding-inline-start:4px;
            }
          }
        }
      }

      table {
        background: transparent;
        thead {
          th {
            color: $dull-text-color;
            border-top: none !important;
            border-bottom: none !important;
          }
        }
        tbody {
          color: $text-color;
          td {
            border-top: none !important;
          }
        }
      }

      .activeSource{
        color: $active-blue !important;
    }

    .view-tags{
      cursor: pointer;
    }

    .deparments-list-wrapper{
      overflow: auto;
      display: inline-flex;
      width: 100%;
      height: calc(100% - 50px) !important;
    }
  </style>
  